/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-25 11:45:05
 * @Explain: 模板管理（邮件、短信）
 */
// type
import type {
  FormDataType,
  TemplateAutoSaveConfigType,
  TemplateListType,
  TemplateTransListType,
} from '@/pages/mailTemplate/data.d';
import { defaultForm } from '@/pages/mailTemplate/varAndFun';

export interface TemplateState {
  mailTemplateForm: FormDataType;
  mailTemplateList: TemplateListType;
  mailTemplateAutoSaveConfig: TemplateAutoSaveConfigType;
  mailTemplateTransList: TemplateTransListType;
  isMarketingDrawerOpened: boolean;
  isTransDrawerOpened: boolean;
}

export type ModelType = {
  namespace: string;
  state: TemplateState;
  reducers: {
    setMailTemplateForm: (
      state: TemplateState,
      action: { payload: any },
    ) => any;
    resetMailTemplateForm: (
      state: TemplateState,
      action: { payload: any },
    ) => any;
    setMailTemplateList: (
      state: TemplateState,
      action: { payload: any },
    ) => any;
    resetMailTemplateList: (
      state: TemplateState,
      action: { payload: any },
    ) => any;
    setMailTemplateAutoSaveConfig: (
      state: TemplateState,
      action: { payload: any },
    ) => any;
    resetMailTemplateAutoSaveConfig: (
      state: TemplateState,
      action: { payload: any },
    ) => any;
    setMailTemplateTransList: (
      state: TemplateState,
      action: { payload: any },
    ) => any;
    resetMailTemplateTransList: (
      state: TemplateState,
      action: { payload: any },
    ) => any;
    setIsMarketingDrawerOpened: (
      state: TemplateState,
      action: { payload: any },
    ) => any;
    setIsTransDrawerOpened: (
      state: TemplateState,
      action: { payload: any },
    ) => any;
  };
};

const TemplateModel: ModelType = {
  namespace: 'TemplateModel',
  state: {
    // 活动表单
    mailTemplateForm: { ...defaultForm },
    mailTemplateList: {},
    mailTemplateAutoSaveConfig: {},
    mailTemplateTransList: {},
    isMarketingDrawerOpened: false,
    isTransDrawerOpened: false,
  },
  reducers: {
    // 邮件模板 - 表单
    setMailTemplateForm(state, action) {
      return {
        ...state,
        mailTemplateForm: action.payload,
      };
    },
    // 邮件模板 - 重置表单
    resetMailTemplateForm(state, action) {
      return {
        ...state,
        mailTemplateForm: { ...defaultForm },
      };
    },
    // 邮件模板 - 列表
    setMailTemplateList(state, action) {
      return {
        ...state,
        mailTemplateList: action.payload,
      };
    },
    // 邮件模板 - 重置列表
    resetMailTemplateList(state) {
      return {
        ...state,
        mailTemplateList: {},
      };
    },

    // 邮件模板 - 自动保存配置项
    setMailTemplateAutoSaveConfig(state, action) {
      return {
        ...state,
        mailTemplateAutoSaveConfig: action.payload,
      };
    },
    // 邮件模板 - 重置自动保存配置项
    resetMailTemplateAutoSaveConfig(state) {
      return {
        ...state,
        mailTemplateAutoSaveConfig: {},
      };
    },

    // 邮件模板 - 列表 trans
    setMailTemplateTransList(state, action) {
      return {
        ...state,
        mailTemplateTransList: action.payload,
      };
    },
    // 邮件模板 - 重置列表 trans
    resetMailTemplateTransList(state) {
      return {
        ...state,
        mailTemplateTransList: {},
      };
    },
    setIsMarketingDrawerOpened(state, action) {
      return {
        ...state,
        isMarketingDrawerOpened: action.payload.isMarketingDrawerOpened,
      };
    },
    setIsTransDrawerOpened(state, action) {
      return {
        ...state,
        isTransDrawerOpened: action.payload.isTransDrawerOpened,
      };
    },
  },
};

export default TemplateModel;
